import React from 'react';
import map from './ntamap';
import './map.scss';
import { PopularDefinition, CityDefinition, HistoryCityDefinition, OnsenDefinition } from './data/defaultDestination';
import { LocationType } from '@/constants';

const destinationsConfig = [
  {
    title: 'City',
    data: CityDefinition,
  },
  {
    title: 'Historical City ',
    data: HistoryCityDefinition,
  },
  {
    title: 'Hot Spring(Onsen)',
    data: OnsenDefinition,
  },
];

type Props = { onSelectLocation: (name: string, code: string, type: number, keepOpen?: boolean) => void };

export default function Map({ onSelectLocation }: Props) {
  const onSelect = location => {
    const { level, title, cd } = location || {};
    if (level !== 'direction') {
      const type = ['pref'].includes(level) ? LocationType.Prefecture : level === 'area' ? LocationType.Area : LocationType.City;
      onSelectLocation(title, cd, type, true);
    }
  };
  React.useEffect(() => {
    map.init(onSelect);
    map.renderMap();
  }, []);
  const onDestinationChange = (title: string, code: string) => {
    const level = map.pref[code] ? 'pref' : map.area[code] ? 'area' : 'district';
    map.set(level, code);
    const type = map.pref[code] ? LocationType.Prefecture : map.area[code] ? LocationType.Area : LocationType.City;
    onSelectLocation(title, code, type, true);
  };
  return (
    <div className="nta-map">
      <div className="content">
        <div id="ZoneTopicPath" className="mapBreadCrumb  text-14 text-blue-1 fw-500 ls-2 lh-16">
          Japan
        </div>

        <div className="row">
          <div className="col-auto">
            <div className="map-container">
              <div id="Map">
                <img src={require('@/assets/images/japan.gif')} width={300} height={211} />
              </div>
            </div>
          </div>
          <div className="col-auto">
            <div className="popular-destinations">
              <div className="title-bar">
                <div className="title text-15 fw-500 ls-2 lh-16 text-blue-1 text-decoration-underline">Popular Destinations</div>
              </div>
              <div className="col text-14 text-dark-1 fw-500">
                {PopularDefinition.map(d => {
                  return (
                    <div
                      key={d.code}
                      onClick={() => {
                        onDestinationChange(d.title, d.code);
                      }}
                    >
                      <button>{d.title}</button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {destinationsConfig.map(des => {
          return (
            <div className="other-destinations" key={des.title}>
              <div className="title-bar row">
                <div className="title text-15 fw-500 ls-2 lh-16 text-blue-1 text-decoration-underline">{des.title}</div>
              </div>
              <div className="row">
                {des.data.map(d => {
                  return (
                    <div
                      className="col-sm-3"
                      key={d.code}
                      onClick={() => {
                        onDestinationChange(d.title, d.code);
                      }}
                    >
                      <button>{d.title}</button>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
